var _style, _g;
const _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgProfileHome = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 151.7 162.1",
    style: {
      enableBackground: "new 0 0 151.7 162.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.profilehome{fill:current;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "profilehome",
    d: "M18.6,138.1h7.2c1.1,0,2.1,0.9,2.1,2.1v0.5c0,1.1-0.9,2.1-2.1,2.1h-5.1c-1.1,0-2.1-0.9-2.1-2.1L18.6,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "profilehome",
    d: "M42.4,81.2c-3.5,0-6.3,2.7-6.4,6.2v37.3h70.5c3.5,0,6.3-2.7,6.4-6.2V87.4c-0.1-3.5-2.9-6.2-6.4-6.2H100 c-14.8,12.4-36.4,12.4-51.2,0H42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "profilehome",
    d: "M75.6,79C85.7,79,94,70.8,94,60.6c0-10.1-8.2-18.4-18.4-18.4c-10.1,0-18.4,8.2-18.4,18.3 C57.2,70.7,65.4,79,75.6,79C75.6,79,75.6,79,75.6,79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "profilehome",
    d: "M75.6,81.3c11.4,0,20.7-9.3,20.7-20.7S87,39.9,75.6,39.9c-11.4,0-20.7,9.2-20.7,20.7 C54.9,72,64.2,81.3,75.6,81.3z M75.6,44.5c8.9,0,16.1,7.2,16.1,16.1c0,8.9-7.2,16.1-16.1,16.1c-8.9,0-16.1-7.2-16.1-16.1 c0,0,0,0,0,0C59.6,51.7,66.7,44.6,75.6,44.5L75.6,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "profilehome",
    d: "M106.5,78.1h-6.4c-0.8,0-1.6,0.3-2.2,0.8c-13.6,11.3-33.3,11.3-46.9,0c-0.6-0.5-1.4-0.8-2.2-0.8h-6.4 c-5.2-0.1-9.5,4.1-9.6,9.3v37.3c0,1.7,1.5,3.1,3.2,3.1h70.6c5.2,0.1,9.5-4.1,9.6-9.3V87.4C116,82.2,111.8,78,106.5,78.1z  M109.7,118.5c0,1.7-1.5,3.1-3.2,3.1H39.2V87.4c0-1.7,1.5-3.1,3.2-3.1h5.2c15.8,12.4,38,12.4,53.8,0h5.2c1.7,0,3.2,1.4,3.2,3.1 c0,0,0,0,0,0L109.7,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "profilehome",
    d: "M139.5,146.8H9.3c-2.7,0-4.8,2.4-4.8,5.4s2.2,5.4,4.8,5.5h130.2c2.6,0,4.8-2.4,4.8-5.5 S142.1,146.8,139.5,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "profilehome",
    d: "M141.2,46.2l-11.1-6.8c0,0.2,0,0.2,0,0l-23.7-13.7L76.5,6.7c-1.5-1-3.5-1-5.1,0L6.8,46.2 c-2.4,1.3-3.3,4.3-2.1,6.8l0.6,1.5c1.1,2.5,4.1,3.7,6.6,2.6c0.1,0,0.2-0.1,0.3-0.1l0.2-0.1l5.5-3.4l53.6-32.8c1.5-1,3.5-1,5.1,0 l53.6,32.8l5.5,3.3c2.3,1.4,5.4,0.7,6.8-1.6c0.1-0.1,0.2-0.3,0.2-0.4c0-0.1,0.1-0.2,0.1-0.3l0.5-1.1 C144.5,50.8,143.6,47.7,141.2,46.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "profilehome",
    d: "M3.4,50.9l0.1,102.9c0,2.1,2.3,3.8,5.1,3.8s5.1-1.7,5.1-3.8L13.6,50.8c0-2.1-2.3-3.8-5.1-3.8 S3.4,48.8,3.4,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "profilehome",
    d: "M134,49.8l0.1,102.9c0,2.1,2.3,3.8,5.1,3.8s5.1-1.7,5.1-3.8l-0.1-102.9c0-2.1-2.3-3.8-5.1-3.8 S134.1,47.6,134,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "profilehome",
    d: "M121.1,137.8h7.2c1.1,0,2.1,0.9,2.1,2.1v0.5c0,1.1-0.9,2.1-2.1,2.1h-5.1c-1.1,0-2.1-0.9-2.1-2.1V137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "profilehome",
    d: "M32.4,142.8c1.4,0,2.5-1.1,2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5 C29.9,141.7,31,142.8,32.4,142.8C32.4,142.8,32.4,142.8,32.4,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "profilehome",
    d: "M115.3,142.8c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5S114,142.8,115.3,142.8 C115.3,142.8,115.3,142.8,115.3,142.8z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProfileHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ProfileHome.2af7fe15.svg";
export { ForwardRef as ReactComponent };